/**
 * Internal dependencies
 */
import { useSelector } from '@/store';

const useAuthState = () => useSelector(({ auth }) => auth);

export default useAuthState;
